export default __webpack_public_path__ + "static/media/articles-next-icon.0784f061.svg";